import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";

import { SliceKeys, tablePaginationInitialValue } from "@sso/constant";
import { RootState } from "@sso/store";
import { SearchColumn } from "@sso/types";
import { getTableSortColumn, queryBuilder } from "@sso/utils";

export const ProductSlice = createSlice({
  name: SliceKeys.PRODUCT,
  initialState: { pagination: tablePaginationInitialValue },
  reducers: {
    setProductPageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
      state.pagination.pageSize = action.payload;
    },
    setProductPageIndex: (state, action: PayloadAction<number>) => {
      state.pagination.pageIndex = action.payload;
    },
    setProductSearchColumn: (state, action: PayloadAction<SearchColumn>) => {
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
      state.pagination.search[action.payload.column] = action.payload;
    },
    clearProductSearchColumn: (state, action: PayloadAction<string>) => {
      const { [action.payload]: deleteItem, ...otherSearchItems } = state.pagination.search;
      state.pagination.search = otherSearchItems;
    },
    setProductSortColumn: (state, action: PayloadAction<string>) => {
      const { column, type } = state.pagination.sort;
      state.pagination.sort = getTableSortColumn(column, action.payload, type);
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
    },
  },
});

export const {
  setProductPageSize,
  setProductPageIndex,
  setProductSortColumn,
  setProductSearchColumn,
  clearProductSearchColumn,
} = ProductSlice.actions;

export const selectProductPagination = createSelector(
  (state: RootState) => state.product.pagination,
  ({ pageSize, totalPages, pageIndex, sort, search }) => ({
    pageSize: { action: setProductPageSize, value: pageSize },
    pagination: {
      totalPages,
      pageIndex,
      action: setProductPageIndex,
    },
    sort,
    search: { object: search, onChange: setProductSearchColumn, onClear: clearProductSearchColumn },
  }),
);

export const selectProductQuery = createSelector(
  (state: RootState) => state.product.pagination,
  ({ pageSize, pageIndex, search, sort }) => queryBuilder(pageSize, pageIndex, search, sort),
);

export default ProductSlice.reducer;
